import React from "react";
import { Link } from "react-router-dom";

import "./styles.scss";

interface CommonLinkProps {
  to: string;
  children: React.ReactNode;
}

/**
 * A wrapper for the Link component that adds a common link style. Should be used for internal links
 * to achive a consisten style.
 * This component was created later, so many older components use the Link component directly. Feel free to
 * update to this component when refactoring.
 */
export const CommonLink: React.FC<CommonLinkProps> = ({ to, children }) => {
  return (
    <Link className="common-link" to={to}>
      {children}
    </Link>
  );
};
